import { accessRole } from "../../../helpers/access_role";
import ErrorAccess from "../../../components/Error/Content/Access";

import IndexView from "./Index/View";
import CreateView from "./Create/View";
import DetailView from "./Detail/View";
// import UpdateView from "./Update/View"
import EditView from "./Edit/View";
import ChartView from "./Charts/View";
//import ChartJabatanView from "./ChartJabatan/View"

// Tugas Tambahan
import CreateTugasTambahanView from "../TugasTambahan/Create/View";
import UpdateTugasTambahanView from "../TugasTambahan/Update/View";
import DetailTugasTambahanView from "../TugasTambahan/Detail/View";

const RouteView = (props) => {
  const queryParams = new URLSearchParams(props.location.search);
  const _tugasTambahan = queryParams.get("tugasTambahan");
  const _create = queryParams.get("create");
  const _detail = queryParams.get("detail");
  const _update = queryParams.get("update");
  const _chart = queryParams.get("charts");
  const _period = queryParams.get("period");
  const _chartJabatan = queryParams.get("chartsJabatan");
  const _delete = queryParams.get("detail");
  const _approve = queryParams.get("approve");
  const _print = queryParams.get("print");
  const _uuid = queryParams.get("uuid");
  const _edit = queryParams.get("edit");
  const _periode = queryParams.get("periode");
  const _periodedate = queryParams.get('periodedate')
  if (_create != null) {
    if (_tugasTambahan != null) {
      return accessRole("create") ? (
        <CreateTugasTambahanView />
      ) : (
        <ErrorAccess />
      );
    } else {
      return accessRole("create") ? <CreateView /> : <ErrorAccess />;
    }
  } else if (_detail != null) {
    if (_tugasTambahan != null) {
      return accessRole("read") ? (
        <DetailTugasTambahanView uuid={_uuid} />
      ) : (
        <ErrorAccess />
      );
    } else {
      return accessRole("read") ? <DetailView uuid={_uuid} periode={_periode} /> : <ErrorAccess />;
    }
  } else if (_update != null) {
    if (_tugasTambahan != null) {
      return accessRole("update") ? (
        <UpdateTugasTambahanView uuid={_uuid} />
      ) : (
        <ErrorAccess />
      );
    } else {
      return accessRole("create") ? <CreateView /> : <ErrorAccess />;
    }
  } else if (_chart != null) {
    return accessRole("read") ? (
      <ChartView uuid={_uuid} period={_uuid} />
    ) : (
      <ErrorAccess />
    );
  } else if (_edit != null) {
    return accessRole("read") ? (
      <EditView uuid={_uuid} period={_uuid} periodedate={_periodedate} />
    ) : (
      <ErrorAccess />
    );
  }
  return accessRole("read") ? <IndexView /> : <ErrorAccess />;
};
export default RouteView;
